import { render, staticRenderFns } from "./weight-data-modal.vue?vue&type=template&id=01221e05"
import script from "./weight-data-modal.vue?vue&type=script&lang=js"
export * from "./weight-data-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports